import ARROW_LEFT from 'assets/images/arrow_left_gray.png'
import LOGO from 'assets/images/logo.png'
import US_FLAG from 'assets/images/us.png'
import IL_FLAG from 'assets/images/israel.png'
import USER_DEFUALT from 'assets/images/icon-user-default.png'
import PLUS_SIGN from 'assets/images/plusSign.jpg'

const Images = {
    ARROW_LEFT,
    LOGO,
    FLAGS: {EN: US_FLAG, HE: IL_FLAG},
    USER_DEFUALT,
    PLUS_SIGN,
}

export default Images
